import Http from "../request-method.js";
import Crypto from "../../utils/utils-crypto.js";

export default {
  //登录，用户登录
  userLogin(acc, pwd) {
    let keyStr = "mfSJ1908d1eER1A6df1EdD1d",
      iv = "E5A1f5A1SD2a1SD2";
    return Http.post("/AppApi/Login", {
      LoginName: acc,
      LoginPwd: pwd,
    });
  },
  //心跳
  heart(data) {
    return Http.post("/AppApi/Heart", data);
  },
  //获取裁判类型
  RefereeType() {
    return Http.get("/AppApi/RefereeType");
  },
  //获取赛事列表
  SelectMatchList(data) {
    return Http.post("/AppApi/SelectMatchList", data);
  },
  //设置裁判信息
  SetRefereeInfo(data) {
    return Http.post("/AppApi/SetRefereeInfo", data);
  },
  //获取比赛运动员信息
  GetMatchUserInfo(uid) {
    return Http.get("/AppApi/MatcherUserInfo", { UserGuid: uid });
  },
  //更新运动员状态
  UpdateUserStatus(uid, s) {
    return Http.post("/AppApi/UserStatus", {
      "UserId": uid,
      "Status": s,
    });
  },
  SubmitScore(data){
    return Http.post("/AppApi/SubmitScore", data);
  },
  RefreshScore(data){
    return Http.get("/AppApi/RefreshScore", data);
  },
  ConfirmScore(data){
    return Http.get("/AppApi/ConfirmScore", data);
  },
  CheckAppOprPwd(data){
    return Http.get("/AppApi/CheckAppOprPwd", data);
  },
  GetSpeedMatchWorldRecord (){
    return Http.get("/AppApi/GetSpeedMatchWorldRecord");
  },
  InstantScore(data){
    return Http.post("/AppApi/InstantScore", data);
  }
};
